export const scoreWordCount = (count) => {
    if (count <= 50 || count > 1050) return 0
    if (count <= 100) return 13.3
    if (count <= 150) return 26.7
    if (count <= 200) return 40
    if (count <= 250) return 53.3
    if (count <= 300) return 66.7
    if (count <= 350) return 80
    if (count <= 400) return 86.7
    if (count <= 450) return 93.3
    if (count > 450 && count <= 650)  return 100
    if (count <= 700) return 93.3
    if (count <= 750) return 86.7
    if (count <= 800) return 80
    if (count <= 850) return 66.7
    if (count <= 900) return 53.3
    if (count <= 950) return 40
    if (count <= 1000) return 26.7
    if (count <= 1050) return 13.3
}
